module.exports = __webpack_public_path__ + "media/images/countrysquared/sk-0644d8c00eb127055c616eb7f154ca2b.svg";